module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/work_img_money-e424bbc367de105b159ab6eb36d79935.png";